import { gql } from "@apollo/client";

export const exportOutput = gql`
  fragment exportOutput on ExportOutput {
    templateId
    templateName
    fileName
    fileBytes
    successful
    message
    fileUniqueId
    fileInternalId
  }
`;
